import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import "./NovidadesModal.css";

const NOVIDADE = {
  titulo: "Troque de projeto ou setor sem sair da tela",
  texto: "Agora tem um botão flutuante dentro dos Cards que abre uma barra com todos os projetos e setores que você tem acesso. Clicou, já entrou — sem precisar voltar para o Container.",
  imgTopo: "https://res.cloudinary.com/dmecovtmm/image/upload/v1786478521/Sem_t%C3%ADtulo.pngffer_uslren.png",
  imgMascote: "https://res.cloudinary.com/dmecovtmm/image/upload/v1786478521/ddd_ff6ibj.png",
};

export default function NovidadesModal({ isOpen, onClose }) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="nvd-overlay" onClick={onClose}>
      <div className="nvd-modal" onClick={(e) => e.stopPropagation()}>
        <button className="nvd-close" onClick={onClose} aria-label="Fechar">
          <FaTimes />
        </button>

        <div className="nvd-hero">
          <div className="nvd-hero__glow" />
          <img src={NOVIDADE.imgTopo} alt="" className="nvd-hero__img" />
          <img src={NOVIDADE.imgMascote} alt="" className="nvd-hero__mascote" />
        </div>

        <div className="nvd-content">
          <span className="nvd-content__eyebrow">Novidade no OnBox</span>
          <h2 className="nvd-content__title">{NOVIDADE.titulo}</h2>
          <p className="nvd-content__subtitle">{NOVIDADE.texto}</p>

          <button className="nvd-cta" onClick={onClose}>
            Entendi, bora trabalhar!
          </button>
        </div>
      </div>
    </div>
  );
}